import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { useOrbitContext } from '../../OrbitContext';
import { ORBIT_L4_DEMO_PARAM, ORBIT_L4_DEMO_SESSION_ID } from './constants';
import { installOrbitL4DemoTransport, setOrbitL4DemoEnabled } from './transport';

installOrbitL4DemoTransport();
// Module saves dispatched through the redux api middleware use the global axios instance.
installOrbitL4DemoTransport(axios);

/** Arms the demo transport with the flag, and opens the demo chat for `?orbit_demo=1`. */
const OrbitL4DemoBridge = ({ enabled }: { enabled: boolean }) => {
  const { resumeSession, openSidebar, sessionId } = useOrbitContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOrbitL4DemoEnabled(enabled);
    return () => setOrbitL4DemoEnabled(false);
  }, [enabled]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!enabled || params.get(ORBIT_L4_DEMO_PARAM) !== '1') {
      return;
    }
    params.delete(ORBIT_L4_DEMO_PARAM);
    navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    if (sessionId !== ORBIT_L4_DEMO_SESSION_ID) {
      resumeSession(ORBIT_L4_DEMO_SESSION_ID);
    }
    openSidebar();
  }, [
    enabled,
    location.pathname,
    location.search,
    navigate,
    openSidebar,
    resumeSession,
    sessionId
  ]);

  return null;
};

export default OrbitL4DemoBridge;
